// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"875361de","297":"04fcffda","643":"e1c66353"}[chunkId] + ".chunk.js";
};